import React, { useContext } from 'react';
import { getOrgNameFromOrgId } from '../../utils/getOrgNameFromOrgId';
import { PriceCalculationContext } from '../../PriceCalculationContext';

function OrgsThatAlreadyHaveThisProduct({ organizationIds }) {
    const { organizationData, resourcedTexts } = useContext(PriceCalculationContext);
    const noOrganizationsThatAlreadyHaveThisProduct = organizationIds.length === 0;

    if (noOrganizationsThatAlreadyHaveThisProduct) {
        return null;
    }

    return (
        <div className="orgs-that-already-have-this-product">
            <hr />

            <h4>{resourcedTexts.theseOrganizationsAlreadyHaveThisProduct}</h4>

            {organizationIds.map((orgId) => (
                <div key={orgId}>{getOrgNameFromOrgId(organizationData, orgId)}</div>
            ))}
        </div>
    );
}

export { OrgsThatAlreadyHaveThisProduct };
